module.exports = __webpack_public_path__ + "assets/img/Preview_tit.735f8e8b.png";